import * as NoteIcons from './NoteIcons'
export const NoteIconsDictionary = {
  100: NoteIcons.NoteIcon100,
  warning: NoteIcons.NoteIconWarning,
  white_check_mark: NoteIcons.NoteIconWhiteCheckMark,
  calendar: NoteIcons.NoteIconCalendar,
  hammer: NoteIcons.NoteIconHammer,
  rocket: NoteIcons.NoteIconRocket,
  writing_hand: NoteIcons.NoteIconWritingHand,
  dart: NoteIcons.NoteIconDart,
  bulb: NoteIcons.NoteIconBulb,
  computer: NoteIcons.NoteIconComputer,
  speech_balloon: NoteIcons.NoteIconSpeechBalloon,
  memo: NoteIcons.NoteIconMemo,
  mega: NoteIcons.NoteIconMega,
  hammer_and_wrench: NoteIcons.NoteIconHammerAndWrench,
  gear: NoteIcons.NoteIconGear,
  file_folder: NoteIcons.NoteIconFileFolder,
  art: NoteIcons.NoteIconArt,
  sparkles: NoteIcons.NoteIconSparkles,
  zap: NoteIcons.NoteIconZap,
  handshake: NoteIcons.NoteIconHandshake,
  world_map: NoteIcons.NoteIconWorldMap,
  wave: NoteIcons.NoteIconWave,
  studio_microphone: NoteIcons.NoteIconStudioMicrophone,
  fire: NoteIcons.NoteIconFire,
  chart: NoteIcons.NoteIconChart,
  spiral_note_pad: NoteIcons.NoteIconSpiralNotePad,
  moneybag: NoteIcons.NoteIconMoneybag,
  briefcase: NoteIcons.NoteIconBriefcase,
  books: NoteIcons.NoteIconBooks,
  question: NoteIcons.NoteIconQuestion,
  bar_chart: NoteIcons.NoteIconBarChart,
  dollar: NoteIcons.NoteIconDollar,
  x: NoteIcons.NoteIconX,
  eyes: NoteIcons.NoteIconEyes,
  scroll: NoteIcons.NoteIconScroll,
  no_entry_sign: NoteIcons.NoteIconNoEntrySign,
  crystal_ball: NoteIcons.NoteIconCrystalBall,
  iphone: NoteIcons.NoteIconIphone,
  book: NoteIcons.NoteIconBook,
  department_store: NoteIcons.NoteIconDepartmentStore,
  crossed_swords: NoteIcons.NoteIconCrossedSwords,
  building_construction: NoteIcons.NoteIconBuildingConstruction,
  construction: NoteIcons.NoteIconConstruction,
  muscle: NoteIcons.NoteIconMuscle,
  microphone: NoteIcons.NoteIconMicrophone,
  boom: NoteIcons.NoteIconBoom,
  earth_americas: NoteIcons.NoteIconEarthAmericas,
  pencil2: NoteIcons.NoteIconPencil2,
  sunny: NoteIcons.NoteIconSunny,
  exclamation: NoteIcons.NoteIconExclamation,
  money_with_wings: NoteIcons.NoteIconMoneyWithWings,
  test_tube: NoteIcons.NoteIconTestTube,
  couch_and_lamp: NoteIcons.NoteIconCouchAndLamp,
  tennis: NoteIcons.NoteIconTennis,
  balloon: NoteIcons.NoteIconBalloon,
  anchor: NoteIcons.NoteIconAnchor,
  school_satchel: NoteIcons.NoteIconSchoolSatchel,
  apple: NoteIcons.NoteIconApple,
  radio: NoteIcons.NoteIconRadio,
  basket: NoteIcons.NoteIconBasket,
  scales: NoteIcons.NoteIconScales,
  clipboard: NoteIcons.NoteIconClipboard,
  pushpin: NoteIcons.NoteIconPushpin,
  airplane: NoteIcons.NoteIconAirplane,
  thought_balloon: NoteIcons.NoteIconThoughtBalloon,
  robot_face: NoteIcons.NoteIconRobotFace,
  peach: NoteIcons.NoteIconPeach,
  package: NoteIcons.NoteIconPackage,
  key: NoteIcons.NoteIconKey,
  seedling: NoteIcons.NoteIconSeedling,
  palm_tree: NoteIcons.NoteIconPalmTree,
  house: NoteIcons.NoteIconHouse,
  heart: NoteIcons.NoteIconHeart,
  credit_card: NoteIcons.NoteIconCreditCard,
  car: NoteIcons.NoteIconCar,
  trophy: NoteIcons.NoteIconTrophy,
  email: NoteIcons.NoteIconEmail,
  phone: NoteIcons.NoteIconPhone,
  one: NoteIcons.NoteIconOne,
  two: NoteIcons.NoteIconTwo,
  three: NoteIcons.NoteIconThree,
  motorway: NoteIcons.NoteIconMotorway,
  arrows_counterclockwise: NoteIcons.NoteIconArrowsCounterclockwise,
  mortar_board: NoteIcons.NoteIconMortarBoard,
  heavy_dollar_sign: NoteIcons.NoteIconHeavyDollarSign,
}
